if (!customElements.get("compare-table")) {
  class ComponentCompareTable extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.totalColumns = parseInt(this.dataset.totalColumns);
      this.displayColumns = parseInt(this.dataset.displayColumns);
      this.hiddenColumns = this.totalColumns - this.displayColumns + 1;

      this.controlledColumns = [];
      for (var i = 0; i < this.hiddenColumns; i++)
        this.controlledColumns.push(this.displayColumns + i);

      if (isMobile && isMobile.any && this.hiddenColumns > 1) this.init();
    }

    init() {
      this.elTable = this;
      this.elTable.setAttribute("style", `--grid-cols: ${this.displayColumns}`);

      this.elColHeads = this.querySelectorAll(".item-grid.table-head");
      let headsValues = this.getHeadValues(this.elColHeads);

      // Adding Select
      this.elColHeads.forEach((elColHead, indexColHead) => {
        if (indexColHead >= this.displayColumns - 1) {
          elColHead.innerHTML = `
                    <div class="body-m">
                        <select class="table-control">
                            ${headsValues
                              .map(
                                (value, index) =>
                                  `<option value="${
                                    this.displayColumns + index
                                  }">${value}</option>`
                              )
                              .join("")}
                        </select>
                    </div>`;
        }
      });

      let cols = [...this.controlledColumns];
      this.showColumns(
        [...cols.splice(1, this.controlledColumns.length)],
        false
      );

      this.initTableControls();
    }

    showColumns(cols, status) {
      var elHiddenColumns = this.querySelectorAll(
        cols.map((h) => `.item-grid[data-index="${h}"]`).join(",")
      );
      Array.from(elHiddenColumns).forEach((elHiddenColumn) => {
        if (status) {
          elHiddenColumn.classList.remove("hide");
        } else {
          elHiddenColumn.classList.add("hide");
        }
      });
    }

    initTableControls() {
      var elTableControls = this.querySelectorAll(".table-control");
      Array.from(elTableControls).forEach((elTableControl) => {
        elTableControl.addEventListener("change", (event) => {
          console.log(event.currentTarget.value, this.controlledColumns);
          this.showColumns(this.controlledColumns, false);
          this.showColumns([event.currentTarget.value], true);

          Array.from(elTableControls).forEach(
            (x) => (x.value = event.currentTarget.value)
          );
        });
      });
    }

    getHeadValues(elColHeads) {
      return Array.from(elColHeads)
        .splice(this.displayColumns - 1, Array.from(elColHeads).length)
        .map((elColHead) => elColHead.querySelector("div").dataset.value)
        .map((x) => x.trim())
        //.map((x) => x.split("<sup>")[0]);
    }
  }
  customElements.define("compare-table", ComponentCompareTable);
}
